module.exports = __webpack_public_path__ + "images/emoji/no_entry_sign.22de0265cc4daab70f55.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/no_entry_sign.png
// module id = acl0
// module chunks = 13